export const getBaseUrl = () => {
  const url = process.env.VUE_APP_MODE === 'test'? "https://test.culturesquare.com" : "https://api.culturesquare.com";
  return url;
};

export const getStoreBaseUrl = () => {
  const url = "https://stores.culturesquare.com";
  return url;
};
export const makeToast = (variant = null, msg) => {
  const result = this.$bvToast.toast(msg, {
    title: "Message",
    variant: variant,
    solid: true,
  });
  return result;
};
export const dashboardData = [
  {
    langClub: {
      text: [
        "Select your local language",
        "Name your language club",
        "Set admission rules: It is free or paid membership?",
        "Publish your calendar",
        "Start admitting members and earn an income",
      ],
      actionText: "Start Here",
      imgUrl: require('@/assets/images/lang-club.jpg'),
      extLink:false,
      url: "/languages/clubs/create",
    },
    instructor: {
      text: [
        "Create customizable language course modules and earn a passive good income",
        "Organize contents that fit your schedule",
        "Schedule time slots for virtual or in person meeting with students around the world",
      ],
      actionText: "Start Here",
      imgUrl: require('@/assets/images/instructor.jpeg'),
      extLink:false,
      url: "/languages/events/create",
    },
    interpreter: {
      text: [
        "List your skill set (which languages you’re capable of interpreting?)",
        "Publish your calendar and have clients reserve time slots",
        "Start generating income",
      ],
      actionText: "Sign Up",
      imgUrl: require('@/assets/images/interpreter.jpeg'),
      extLink:false,
      url: "/languages/interpreters/create",
    },
    donate: {
      text: [
        "We are a social movement rooting for a more diverse and inclusive world",
        "With your contribution we will be able to Host Events that encourage cultural diversity and inclusion.",
      ],
      actionText: "Donate",
      imgUrl: require('@/assets/images/donate.jpeg'),
      extLink:false,
      url: "/donate"
    },
    vendor: {
      text: [
        "Our shopping experience is designed to bring unique local items from around the world to your doorstep",
        "You don’t need to travel to a foreign country to buy that handcraft jewelry to gift to your partner.",
        "Suppliers or vendors will now sell their products to an international customer base.",
      ],
      actionText: "Sign Up",
      imgUrl: require('@/assets/images/vendor.jpeg'),
      extLink:true,
      url: "https://stores.culturesquare.com/login"
    },
    cook: {
      text: [
        "Finding an authentic traditional dish these days is rare.",
        "At Culture Square, our goal is to connect you to a global network of traditional food enthusiasts",
        "Share your recipes and we will connect you to people and companies that would love to add a touch of diversity to their special events.",
        "Add your recipe now.",
      ],
      actionText: "Create a Recipe",
      imgUrl: require('@/assets/images/cook.jpeg'),
      extLink:false,
      url: "/recipes/create"
    },
    recipe: {
      text: [
        "Explore best authentic recipes from around the world",
        "Discover how much it will cost you to taste it and where to find it",
        "Review the dish by telling other your experience.",
        "Still bored of cooking the same thing week in, week out.",
        "Hire a cook or a professional chef that will deliver a special authentic menu to spice up your event.",
      ],
      actionText: "Explore Recipes",
      imgUrl: require('@/assets/images/recipes.jpeg'),
      extLink:false,
      url: "/recipes"
    },
    hostEvent: {
      text: [
        "Share of a moment with a stranger",
        "Eat with guests from around the world",
        "Expose your employees to an environment that can help them develop essential intercultural --competencies like mindfulness, cognitive and behavioral flexibility, cross-cultural empathy, and tolerance.",
        "Turn your leads into customers by organizing an all -inclusive company event with communities.",
      ],
      actionText: "Create an Event",
      imgUrl: require('@/assets/images/host-event.jpeg'),
      extLink:false,
      url: "/listings/events/create"
    },
    joinEvent: {
      text: [
        "Are you new in the city?",
        "Are you feeling disoriented or having cultural shock?",
        "Explore some of the best exciting cultural event near you",
      ],
      actionText: "Join an Event",
      imgUrl: require('@/assets/images/attend-event.jpeg'),
      extLink:false,
      url: "/listings/events"
    },
    product: {
      text: [
        "Get access to exclusive product",
        "Free Shipping",
        "Unlimited discount options.",
        "You can connect virtually anywhere with us.",
      ],
      actionText: "Buy Here",
      imgUrl: require('@/assets/images/buy-product.jpeg'),
      extLink:true,
      url: "https://stores.culturesquare.com/"
    },
  },
];
